module.exports = __webpack_public_path__ + "static/media/hashtag.690f6a49.svg";